module.exports = __webpack_public_path__ + "img/img_chamarra.9e4fca6a.svg";